export default [
	{
        path: '/seller-dashboard',
        component: () => import('../components/Dashboard.vue'),
        name: 'seller-dashboard',
        meta: {                  
        }
    },

]